import { render, staticRenderFns } from "./VSelectSearchProductGroup.vue?vue&type=template&id=2e97f52d&scoped=true&"
import script from "./VSelectSearchProductGroup.vue?vue&type=script&lang=js&"
export * from "./VSelectSearchProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./VSelectSearchProductGroup.vue?vue&type=style&index=0&id=2e97f52d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97f52d",
  null
  
)

export default component.exports